const syncedMap = new Map<string, number>();

export const isSyncedTalkId = (talkId: string, seconds: number = 120) => {
  const d = Date.now();
  const syncedInfo = syncedMap.get(talkId);
  return syncedInfo && d - syncedInfo < seconds * 1000;
};

/** 2分钟内已上报的不重复上报 */
export default function getNeedSyncIds(talkIds: string[], seconds: number = 120) {
  const needSyncTalkIds: string[] = [];

  talkIds.forEach((talkId) => {
    if (!isSyncedTalkId(talkId, seconds)) {
      needSyncTalkIds.push(talkId);
    }
    addSyncedTalkId(talkId);
  });
  return needSyncTalkIds;
}

export const addSyncedTalkId = (talkId: string) => {
  syncedMap.set(talkId, Date.now());
};
